angular.module('dpw.components')
    .constant('uiConfig', {
        popUpzIndexBase: 100
    })
    .factory('popup', ['$rootScope', '$compile', '$interpolate', 'uiConfig', function ($rootScope, $compile, $interpolate, uiConfig) {
        return function (options) {
            var t = $interpolate('<div class="popup {{extraClass}}" ' +
                'dpw-popup title="{{title}}" show-close-btn="{{showCloseBtn}}"' +
                'show-header="{{showHeader}}">' +
                '<div {{directiveName}}></div>' +
                '</div>')(options);
            var $dom = $compile($(t))(options.scope);
            options.scope.$on('popupDestroy', function () {
                options.scope.$destroy();
            });
            var maxZIndex = $('.popup').length;
            $dom.css('z-index', uiConfig.popUpzIndexBase + maxZIndex);
            if (options.stayInSection) {
                $dom.css('top', $(document).scrollTop() + "px");
            }

            $('body').append($dom);

            var deregister = $rootScope.$on('$routeChangeSuccess', function () {
                options.scope.$destroy();
                deregister();
            });
        };
    }])
    .factory('popupUtil', ['popup', '$rootScope', '$sce', function (popup, $rootScope, $sce) {

        function createModal(options) {
            var scope = $rootScope.$new();
            var modalClasses = options.extraClasses || [];
            var showCloseBtn = _.isUndefined(options.showCloseBtn) ? true : options.showCloseBtn;
            var actions = {
                disable: function ($event) {
                    $event.preventDefault();
                },
                close: function () {
                    scope.$destroy();
                },
                callback: function (action) {
                    return function ($event) {
                        $event.preventDefault();
                        scope.$destroy();
                        _.isFunction(action) && action();
                    };
                }
            };

            scope.settings = {
                title: options.title,
                content: $sce.trustAsHtml(options.content),
                buttons: _.map(options.buttons, function (btn) {
                    if (btn.disabled) {
                        btn.onClick = actions.disable;
                    } else {
                        btn.onClick = _.isFunction(btn.action) ?
                            actions.callback(btn.action) :
                            actions[btn.action] || angular.noop;
                    }

                    return btn;
                }) || []
            };

            popup({
                scope: scope,
                directiveName: options.directive,
                showCloseBtn: showCloseBtn,
                extraClass: modalClasses.join(' ')
            });
        }

        return {
            /**
             * Create a modal window which shows title, content and an OK button.
             *
             * @param {Object} options
             * @param {String} [options.title='We are sorry!']      - Modal title
             * @param {String} options.content                      - Modal content
             * @param {String} [options.btnName='OK']               - Label for OK button
             * @param {String} [options.btnStyle='button-orange']   - ClassName for OK button
             * @param {Boolean} [options.showCloseBtn=true]         - Show close button or not
             * @param {Function|String} [options.callback='close']  - Callback when clicking on OK button.
             *
             * @example
             * popupUtils.ok({
             *   title: 'OK Modal Example',
             *   content: 'Message goes here',
             *   btnName: 'Got it',
             *   btnStyle: 'button-orange',
             *   showCloseBtn: false,
             *   callback: function () {} || 'close'
             * });
             */
            ok: function (options) {
                options.title = options.title || 'We are sorry...';

                createModal(_.assign(options, {
                    directive: 'dpw-popup-common',
                    buttons: [{
                        label: options.btnName || 'OK',
                        style: 'button-orange' || options.btnStyle,
                        action: options.callback || 'close'
                    }]
                }));
            },

            /**
             * Create a modal window which shows title, content and two buttons.
             *
             * @param {Object} options
             * @param {String} [options.title='Confirmation']   - Modal title
             * @param {String} options.content                  - Modal content
             * @param {Array}  options.buttons                  - Buttons configurations
             * @desc A button configuration is an object which has the following properties:
             *         * {String} label - Button label
             *         * {String} style - Button className
             *         * {Function|String} action - Button callback
             * @param {Boolean} [options.showCloseBtn=true]     - Show close button or not
             *
             * @example
             *
             * popupUtils.confirm({
             *   content: 'Remove [ReadAccounts] permission from your app?'
             *   buttons: [
             *     { label: 'Cancel', style: 'button-with-border', action: 'close' },
             *     { label: 'OK', style: 'button-orange', action: function () {} }
             *   ],
             *   showCloseBtn: false
             * });
             */
            confirm: function (options) {
                options.title = options.title || 'Confirmation';

                createModal(_.assign(options, {
                    directive: 'dpw-popup-confirmation'
                }));
            },

            /**
             * Create a modal window which displays a Youtube video.
             *
             * @param {Object} options
             * @param {String} options.url      - Youtube URL
             * @param {String} [options.width]  - The width of the youtube video
             *
             * @example
             * popupUtils.video({
             *      url: 'https://www.youtube.com/watch?v=70FJpXFFaWs',
             *      width: '640px'
             * });
             */
            video: function (options) {
                options = options || {};
                var newScope = $rootScope.$new();
                newScope.config = {
                    videoUrl: options.url,
                    width: options.width,
                    close: function () {
                        newScope.$destroy();
                    }
                };

                popup({
                    scope: newScope,
                    directiveName: 'dpw-popup-youtube-video',
                    showHeader: false,
                    extraClass: 'popup-auto-width'
                });
            }
        };
    }]).directive('dpwPopupCommon', [function () {
    return {
        restrict: 'A',
        scope: true,
        controller: ['$scope', function () {
        }],
        templateUrl: 'dpw-popup-utils.html'
    };
}]).directive('dpwPopupConfirmation', [function () {
    return {
        restrict: 'A',
        scope: true,
        controller: [function () {
        }],
        templateUrl: 'dpw-popup-utils.html'
    };
}]).directive('dpwPopup', [function () {
    return {
        restrict: 'A',
        transclude: true,
        scope: {
            title: '@',
            showCloseBtn: '@',
            showHeader: '@'
        },
        controller: ['$scope', '$element', function ($scope, $element) {
            $scope.$on('$destroy', function () {
                $element.remove();
            });
            this.close = function () {
                $scope.$emit('popupDestroy');
            };
        }],
        link: function () {
            $('.popup-absolute').scrollintoview();
        },
        controllerAs: 'ctrl',
        templateUrl: 'dpw-popup.html'
    };
}]);
